import { Component, Input } from '@angular/core';
import {
  SellionsEngineCalendarEvent
} from '../../../modules/calendar/services/events-service/events-service';
import { TextServiceProvider } from '../../../modules/core/services/text-service/text-service';
import { Utils } from '../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/utils.class'
import {
  ProcessEntry,
  ScreenActions,
} from '../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/screen-actions.interface';
import {
  TableConfig
} from '../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/table/interfaces/table-config.interface';
import { ScreenActionCallback } from './screen-action-callback';

@Component({
  selector: 'sellions-dynamic-event',
  templateUrl: 'sellions-dynamic-event.html',
})
export class SellionsDynamicEventComponent {
  public event: SellionsEngineCalendarEvent;
  infoTextTemplate: string;
  subInfoTextTemplate: string;
  subDateTextTemplate: string;
  additionalTextTemplate: string;
  screenActions: ScreenActions;
  screenActionCallback: ScreenActionCallback;

  constructor(public textService: TextServiceProvider) {}

  evaluateText(template: string) {
    return Utils.evaluateString(template, this.event);
  }

  getStartDate() {
    // @ts-ignore
    let startDate = this.event.startDate as string;
    return startDate ? (startDate.endsWith('Z') ? startDate : startDate + 'Z') : startDate;
  }

  getConfig() {
    return {
      screenActions: this.screenActions
    } as TableConfig ;
  }

  isContextMenuVisible(): boolean {
    return (
      this.screenActions &&
      this.screenActions.processList &&
      this.screenActions.processList.find((process) => process.contextMenuVisible) != null
    );
  }

  onContextMenuClicked($event:any, entry: ProcessEntry) {
    this.screenActionCallback.onActionClick(this.event, entry);
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-dynamic-event/sellions-dynamic-event.ts